import React from 'react'
import styled from 'styled-components'
import Helmet from 'react-helmet'

import StandardWrapper from '../components/standardWrapper'
import StuffTile from '../components/stuffTile'
import matrixPreview from '../images/matrixPreview.png'
import jumpPreview from '../images/jumpPreview.png'
import countdownPreview from '../images/countdownPreview.png'
import pongPreview from '../images/pongPreview.png'
import puzzlerotationPreview from '../images/puzzlerotationPreview.png'
import gugustoPreview from '../images/gugustoPreview.png'

const TileContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: center;
`

// TODO
const data = [
    { title: 'Puzzlerotation', description: 'Finds the solution by rotating the puzzle', url: 'https://stuff.birkenstab.de/bwinf16R1A3', image: puzzlerotationPreview },
    { title: 'Timetable', description: 'My university timetable', url: 'https://tt.birkenstab.de/' },
    { title: 'SSH Pong game', description: 'Play the classic Pong game via ssh', url: 'https://pong.birkenstab.de', image: pongPreview },
    { title: 'Ausredengenerator', description: 'Generiert dir immer die perfekte Ausrede', url: 'https://ausrede.birkenstab.de' },
    { title: 'Matrix', description: 'Animation of falling characters', url: 'https://matrix.birkenstab.de', image: matrixPreview },
    { title: 'Jump', description: 'Doodle Jump like jumping game, created 2013', url: 'https://stuff.birkenstab.de/jump', image: jumpPreview },
    { title: 'Zahlrat', description: 'The famous Zahlrat algorithm implemented in JavaScript', url: 'https://stuff.birkenstab.de/zahlrat' },
    { title: 'Countdown', description: 'Customizable countdown page', url: 'https://cd.birkenstab.de/#2018-12-24', image: countdownPreview },
    { title: 'Scripts', description: 'Useful scripts and config files', url: 'https://scripts.birkenstab.de' },
    { title: 'Gugusto', description: 'A Jump\'n\'Run sidescroller created as part of the game programming lecture', url: 'https://github.com/Birkenstab/gugusto/releases', image: gugustoPreview },
]

const StuffPage = () => (
    <StandardWrapper>
        <Helmet
            title="Stuff – Birkenstab"
            meta={[
                { name: 'keywords', content: 'stuff, projects, websites, portfolio' }
            ]}
        />
        <h1>Stuff</h1>
        <p>Stuff I made. Boring, exciting and fun</p>

        <section>
            <h2>Featured</h2>
            <TileContainer>
                {
                    data.map((entry, index) => (<StuffTile
                        entry={entry}
                        key={index}
                    />))
                }
            </TileContainer>
        </section>
    </StandardWrapper>
)

export default StuffPage



// WEBPACK FOOTER //
// ./src/pages/stuff.js